import {
	COLOR_SEARCH_PARAM,
	DEFAULT_LOOK_ID,
	LOOK_SEARCH_PARAM,
	SIZE_SEARCH_PARAM,
} from 'product/constants/constants'

import type { Color, FullProduct, Look, Size } from '../../types/FullProduct'

export type GetSelectedInfoProps = {
	colors: FullProduct['colors']
	searchParams: Record<string, string>
}

export function getSelectedColor({
	colors,
	searchParams,
}: GetSelectedInfoProps): Color {
	const selectedColor =
		colors.find((color) => color.id === searchParams[COLOR_SEARCH_PARAM]) ||
		colors.find((color) => !color.relatedProductId)

	if (!selectedColor) {
		throw new Error('[GetSelectedColor] Couldnt find a non related color')
	}

	return selectedColor
}

export function getSelectedLook(params: GetSelectedInfoProps): Look {
	const selectedColor = getSelectedColor(params)

	return (
		selectedColor.looks[params.searchParams[LOOK_SEARCH_PARAM]] ||
		selectedColor.looks[DEFAULT_LOOK_ID]
	)
}

export function getSelectedSize(
	params: GetSelectedInfoProps
): Size | undefined {
	const color = getSelectedColor(params)
	const sizeId = params.searchParams[SIZE_SEARCH_PARAM]

	const isUniqueSize = color.sizes.length === 1

	if (sizeId && !isUniqueSize) {
		return color.sizes.find((size) => size.id === sizeId && size.available)
	}

	return isUniqueSize ? color.sizes[0] : undefined
}
